// extracted by mini-css-extract-plugin
export default {"card":"animated-grid_card__6zVGi","animatedGrid":"animated-grid_animatedGrid__ZXXQn","cardEntrance":"animated-grid_cardEntrance__ApMU7"};